module.exports = __webpack_public_path__ + "img/logo.bffe8a85.png";